import { Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import genericStyles from 'utils/genericStyles'

export const UrlNotFound = () => {
  const { t } = useTranslation()
  const genericClasses = genericStyles()

  return (
    <div className={genericClasses.noAccessPageDiv}>
      <Paper className={genericClasses.noAccessPagePaper}>
        <Typography variant="h5" align="center">
          {t<string>('text.url_not_found')}
        </Typography>
        <Typography variant="body1" align="center">
          {t<string>('text.url_not_found_description')}
        </Typography>
      </Paper>
    </div>
  )
}

export default UrlNotFound
